import Enum from "./Enum";

export default Enum.create( {
	USER_LOGIN: "USER_LOGIN",
	USER_LOGOUT: "USER_LOGOUT",
} );
